import { render, staticRenderFns } from "./FloatingNav.vue?vue&type=template&id=b6fe1552&"
import script from "./FloatingNav.vue?vue&type=script&lang=js&"
export * from "./FloatingNav.vue?vue&type=script&lang=js&"
import style0 from "./FloatingNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VSpeedDial})
